<template>
	<div class="index">
		<!-- banner图 -->
		<div class="banenr">
			<img src="../../assets/home/home_banner.png" >
			<div class="resourceBar">
				<div class="resourceBar_c">
					<div class="item">
						<span>
							<img src="../../assets/home/icon1.png" >
						</span>
						<span>资源总数：{{number.resouceCount}}</span>
					</div>
					<div class="item">
						<span>
							<img src="../../assets/home/icon2.png" >
						</span>
						<span>共建课程：{{number.commonCount}}</span>
					</div>
					<div class="item">
						<span>
							<img src="../../assets/home/icon3.png" >
						</span>
						<span>入驻学校：{{number.schoolCount}}</span>
					</div>
					<div class="item">
						<span>
							<img src="../../assets/home/icon4.png" >
						</span>
						<span>下载数量：{{number.downCount}}</span>
					</div>
				</div>
			</div>
		</div>
		<div class="home_wrap">
			<!-- 最热资源 -->
			<div class="hot" @click="goDetail(10,intro.id)">
				<p>{{intro.title}}</p>
				<p v-html="intro.content"></p>
			</div>
			<!-- 轮播 -->
			<div class="swiper">
				<div class="swiper_left">
					<div class="swiper-container">
						<div class="swiper-wrapper">
							<div class="swiper-slide" v-for="item in top_banner" @click="goDetail(10,item.id)">
								<img :src="item.sz_img">
							</div>
						</div>
					</div>
					<div class="words">
						<div class="title">{{play_title}}</div>
						<div class="point">
							<div class="swiper-pagination"></div>
						</div>
					</div>
				</div>
				<div class="swiper_right">
					<div class="share_title">特别推荐</div>
					<div class="list">
						<div class="listitem" v-if="specailList.length > 0 " v-for="(item,index) in specailList" @click="goDetail(10,item.id)">{{item.title}}</div>
						<div class="nodata" v-if="specailList.length == 0">暂无数据</div>
					</div>
				</div>
			</div>
			<!-- 思政要闻 -->
			<div class="szyw">
				<div class="szyw_left">
					<div class="szyw_title share_title1">
						<div :class="mid2 == 3?'selected':''" @click="mid2 = 3;activity()">思政要闻</div>
						<div :class="mid2 == 4?'selected':''" @click="mid2 = 4;activity()">通知公告</div>
					</div>
					<div class="szyw_box">
						<div class="box_item" 
							v-for="(item,index) in szhdList" 
							v-if="szhdList.length > 0" 
							@click="goDetail(10,item.id)">
							<div class="word">
								<div class="title">{{item.title}}</div>
								<div class="subtitle" v-html="item.content"></div>
							</div>
						</div>
						<div class="nodata" v-if="szhdList.length == 0"></div>
					</div>
				</div>
				<div class="szyw_right">
					<div class="share_title">共享排行</div>
					<div class="szyw_list">
						<div class="gxph_item" v-if="school_rank.length > 0" v-for="(item,index) in school_rank" :key="index">
							<span v-if="index<3">
								<img :src="item.logo" />
							</span>
							<span v-if="index>2">{{index+1}}</span>
							<span>{{item.school}}</span>
							<span class="count">{{item.count}}&nbsp;部</span>
						</div>
						<div class="nodata" v-if="school_rank.length == 0"></div>
					</div>
				</div>
			</div>
			<!-- 获奖作品 -->
			<div class="reward">
				<div class="reward_left">
					<div class="share_title1">
						<div>思政课获奖作品 </div>
					</div>
					<div class="reward_list">
						<div class="item" v-if="index < 2" v-for="(item,index) in szkc" @click="goDetail(item.bs_id,item.id)">
							<div class="left_img">
								<div>
									<img :src="item.v_img" >
									<p class="title">{{item.title}}</p>
								</div>
								<p class="title">{{item.title}}</p>
							</div>
						</div>
						<div class="item item1" v-if="index >= 2" v-for="(item,index) in szkc" @click="goDetail(item.bs_id,item.id)">
							<p class="title">{{item.title}}</p>
						</div>
					</div>
				</div>
				<div class="reward_right">
					<div class="share_title1">
						<div>课程思政获奖作品</div>
					</div>
					<div class="reward_list">
						<div class="item" v-if="index < 2" v-for="(item,index) in kcsz" @click="goDetail(item.bs_id,item.id)">
							<div class="left_img">
								<div>
									<img :src="item.v_img" >
									<p class="title">{{item.title}}</p>
								</div>
								<p class="title">{{item.title}}</p>
							</div>
						</div>
						<div class="item item1" v-if="index >= 2" v-for="(item,index) in kcsz" @click="goDetail(item.bs_id,item.id)">
							<p class="title">{{item.title}}</p>
						</div>
					</div>
				</div>
			</div>
			<!-- 红色圣地 -->
			<div class="redplaceWrap">
				<div class="centertitle">
					<div>红色圣地</div>
				</div>
				<div class="redplace swiper-container">
					<div class="swiper-wrapper">
						<div class="swiper-slide">
							<img src="../../assets/home/qj1.png" >
						</div>
						<div class="swiper-slide">
							<img src="../../assets/home/qj2.png" >
						</div>
						<div class="swiper-slide">
							<img src="../../assets/home/jq3.png" >
						</div>
					</div>
					<!-- 左右切换箭头 -->
					<div class="swiper-button-prev dq4_prev"></div>
					<div class="swiper-button-next dq4_next"></div>
				</div>
			</div>
			<!-- 优质资源 -->
			<div class="goodRoursce">
				<div class="centertitle">
					<div>优质资源</div>
				</div>
				<div class="goodlist">
					<div class="item" v-for="item in resource" v-if="resource.length > 0" @click="goDetail(item.bs_id,item.id)">
						<div class="top_img">
							<img :src="item.v_img" >
						</div>
						<div class="bottom">
							<div class="title">{{item.title}}</div>
							<div class="sub_title">{{item.content}}</div>
						</div>
					</div>
					<div class="nodata" v-if="resource.length == 0"></div>
				</div>
			</div>
			<!-- 入驻院校 -->
			<div class="school">
				<div class="centertitle">
					<div>入驻院校</div>
				</div>
				<div class="school_swiper swiper-container">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-if="school_list.length > 0" v-for="item in school_list">
							<div>
								<img :src="item.logo" >
								<div class="school_name">{{item.name}}</div>
							</div>
						</div>
						<div class="nodata" v-if="school_list.length == 0"></div>
					</div>
				</div>
				<div class="swiper-pointer">
					<div class="swiper-pagination"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Swiper from 'swiper';
	import { shouye } from '@/axios';
	export default{
		data(){
			return{
				// 顶部轮播
				top_banner:[],
				// 顶部推荐
				intro:{
					title:"",
					content:""
				},
				// 顶部导航播放标题
				play_title:"",
				// 特别推荐
				specailList:[],
				// 思政活动数据
				mid2:3,
				// 思政活动
				szhdList:[],
				// 学校排名
				school_rank:[],
				// 优质资源
				resource:[],
				// 入驻院校
				school_list:[],
				// 思政课程获奖
				szkc:[],
				// 课程思政获奖
				kcsz:[],
				number:{
					commonCount: 0,
					downCount: 0,
					resouceCount: 0,
					schoolCount: 0
				}
			}
		},
		methods:{
			// 首页数据
			indexData(){
				var that = this;
				//顶部数据
				shouye.introduction().then(res => {
					if(res.code == 200){
						if(res.data != null && res.data.length > 0){
							that.intro = {
								title:res.data[0].title,
								content:res.data[0].content,
								id:res.data[0].id
							}
						}
					}
				});
				//顶部轮播
				shouye.banner().then(res => {
					if(res.code == 200){
						if(res.data != null && res.data.length > 0){
							that.top_banner = res.data;
							that.play_title = res.data[0].title;
							setTimeout(function() {
								// 顶部轮播
								var mySwiper = new Swiper ('.swiper_left .swiper-container', {
									pagination: {
										el: '.point .swiper-pagination',
									},
									speed:1000,
									loop:that.top_banner.length>1?true:false,
									autoplay: {
										delay:2000,
										disableOnInteraction: false
									},
									on: {
										slideChangeTransitionStart: function(){
											if(that.top_banner.length > this.realIndex){
												that.play_title = that.top_banner[this.realIndex].title
											}
										},
									},
								})
							}, 300);
						}
					}
				});
				// 特别推荐
				shouye.specail().then(res => {
					if(res.code == 200){
						if(res.data != null && res.data.length > 0){
							that.specailList = res.data
						}else{
							that.specailList = []
						}
					}
				});
				// 共享排名
				shouye.shareRank().then(res => {
					if(res.code == 200){
						if(res.data != null && res.data.length > 0){
							that.school_rank = res.data
						}else{
							that.school_rank = []
						}
					}
				});
				// 优质资源
				shouye.excellent().then(res => {
					if(res.code == 200){
						if(res.data != null && res.data.length > 0){
							that.resource = res.data
						}else{
							that.resource = []
						}
					}
				});
				// 入驻院校
				shouye.settle().then(res => {
					if(res.code == 200){
						if(res.data != null && res.data.length > 0){
							that.school_list = res.data;
							setTimeout(function() {
								// 院校轮播
								var mySwiper2 = new Swiper('.school_swiper',{
									slidesPerView:4,
									slidesPerColumn : 2,
									spaceBetween : 18,
									slidesPerGroup : 8,
									observer:true,//修改swiper自己或子元素时，自动初始化swiper
									observeParents:true,//修改swiper的父元素时，自动初始化swiper
									speed:1000,
									autoplay: {
										delay:2000,
										disableOnInteraction: false
									},
									slidesPerColumnFill : 'row',
									pagination: {
										el: '.swiper-pointer .swiper-pagination',
									},
								})
							}, 300);
						}else{
							that.school_list = [];
						}
					}
				});
				// 获奖winWorks
				shouye.winWorks().then(res => {
					if(res.code == 200){
						that.kcsz = res.data.kcsz;
						that.szkc = res.data.szkc;
					}
				});
				// 获奖winWorks
				shouye.number().then(res => {
					if(res.code == 200){
						that.number = res.data;
					}
				});
			},
			// 思政活动
			activity(){
				var that = this;
				shouye.szhdList({
					mid2:that.mid2
				}).then(res => {
					if(res.code == 200){
						if(res.data != null && res.data.length > 0){
							that.szhdList = res.data
						}else{
							that.szhdList = []
						}
					}
				})
			},
			// 详情
			goDetail(bsid,id){
				this.$emit("highLight",this.$route.query.index,bsid,id,1)
			}
		},
		mounted(){
			var that = this;
			that.indexData();
			that.activity();
			// 红色圣地轮播
			var mySwiper1 = new Swiper('.redplace', {
				effect: 'coverflow',
				centeredSlides: true,
				slidesPerView: 'auto',
				loop:true,
				speed:1000,
				autoplay: {
					delay:2000,
					disableOnInteraction: false
				},
				coverflowEffect: {
					rotate: 30,
					stretch: 0,
					depth: 150,
					modifier: 1.2,
					slideShadows: true,
				},
				on: {
					click:function(){
						if(this.realIndex == 0){
							window.open("https://s27.jiuye.net/p2/vizen_edu_pc/index.html?appId=1904053579")
						}else if(this.realIndex == 1){
							window.open("https://s27.jiuye.net/p2/vizen_edu_pc/index.html?appId=1903179221")
						}else{
							window.open("https://s27.jiuye.net/p2/vizen_edu_pc/index.html?appId=1904061640")
						}
					}
				},
				navigation: {
					clickable: true,
					nextEl: '.dq4_next',
					prevEl: '.dq4_prev',
				},
			});
		},
		created() {
			this.$emit("highLight",1,"","","");
		}
	}
</script>

<style lang="scss">
	@import '@/common/index.scss';
	.index{
		width: 100%;
		.banenr{
			position: relative;
			width: 100%;
			img{
				width: 100%;
				height: auto;
			}
			.resourceBar{
				position: absolute;
				bottom: 0;
				width: 100%;
				height: 60px;
				background: rgba(56,56,56,.6);
				&_c{
					height: 100%;
					margin: auto;
					display: flex;
					align-items: center;
					justify-content: space-between;
					width: $indexWidth;
					.item{
						font-family: $indexFontTitle;
						display: flex;
						align-items: center;
						height: 100%;
						font-size: 20px;
						color: #fff;
						span:nth-child(1){
							display: block;
							height: 22px;
							width: 22px;
							margin-right: 7px;
							img{
								width: 100%;
							}
						}
					}
				}
			}
		}
		.home_wrap{
			width: $indexWidth;
			margin: auto;
			min-width: 1200px;
			// 最热资源
			.hot{
				cursor: pointer;
				width: 100%;
				margin: 20px auto;
				>p:nth-child(1){
					font-family: $indexFontTitle;
					text-align: center;
					color: $indexColor2;
					font-size: 30px;
					line-height: 35px;
					margin-bottom: 10px;
					max-height: 35px;
					overflow: hidden;
					font-weight: bold;
					overflow: hidden;
					display: -webkit-box;
					word-break: break-all;
					text-overflow: ellipsis; 
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 1;
				}
				>p:nth-child(2){
					color: $indexColor3;
					font-size: 16px;
					line-height: 24px;
					max-height: 48px;
					overflow: hidden;
					display: -webkit-box;
					word-break: break-all;
					text-overflow: ellipsis; 
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
				}
			}
			.hot:hover{
				p{
					color: #bb0000 !important;
				}
			}
			// 轮播
			.swiper{
				width: 100%;
				display: flex;
				justify-content: space-between;
				height: 500px;
				&_left{
					height: 100%;
					width: $indexLeftWidth;
					position: relative;
					background: rgba(0,0,0,0.1);
					border-radius: 4px;
					overflow: hidden;
					.swiper-container{
						width: 100%;
						height: 100%;
						font-size: 20px;
						.swiper-slide{
							height: 100%;
							width: 100%;
							img{
								width: 100%;
								height: 100%;
								object-fit: cover;
							}
						}
					}
					.words{
						z-index: 10;
						position: absolute;
						bottom: 0;
						width: 100%;
						padding: 0 2%;
						box-sizing: border-box;
						height: 72px;
						display: flex;
						align-items: center;
						justify-content: space-between;
						background: rgba(0,0,0,.6);
						color: #fff;
						font-size: 20px;
						.title{
							overflow: hidden;
							width: 70%;
						}
						.point{
							width: 27%;
							text-align: right;
							.swiper-pagination-bullet {
								background: #fff !important;
								opacity: 0.39;
							}
							.swiper-pagination-bullet-active{
								opacity: 1 !important;
								background: #fff !important;
							}
						}
					}
				}
				&_right{
					height: 100%;
					width: $indexRightWidth;
					.list{
						margin-top: 10px;
						.listitem{
							padding-left: 2%;
							box-sizing: border-box;
							width: 100%;
							cursor: pointer;
							color: $indexColor1;
							font-size: 16px;
							line-height: 43px;
							height: 43px;
							overflow: hidden;
							display: -webkit-box;
							word-break: break-all;
							text-overflow: ellipsis; 
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 1;
							&:hover{
								color: #bb0000;
							}
						}
					}
				}
			}
			// 思政要闻
			.szyw{
				width: 100%;
				margin-top: $indexMargin;
				display: flex;
				justify-content: space-between;
				&_left{
					width: $indexLeftWidth;
					.szyw_title{
						height: 50px;
						line-height: 50px;
						width: 100%;
						display: flex;
						align-items: center;
						border-bottom: 1px solid #D5D5D5;
						font-size: 24px;
						color: $indexColor2;
						font-weight: bold;
						font-family: $indexFontTitle;
						>div{
							cursor: pointer;
							margin-right: 40px;
							border-bottom: 3px solid rgba(0,0,0,0);
						}
						>div:hover{
							color: #bb0000;
							border-bottom: 3px solid #bb0000;
						}
					}
					.szyw_box{
						width: 100%;
						margin-top: 10px;
						display: flex;
						flex-wrap: wrap;
						justify-content: space-between;
						.box_item{
							width: 387px;
							cursor: pointer;
							margin-bottom: 10px;
							.word{
								width: 100%;
								.title{
									color: $indexColor;
									font-size: 18px;
									line-height: 40px;
									height: 40px;
									font-weight: bold;
									overflow: hidden;
									display: -webkit-box;
									word-break: break-all;
									text-overflow: ellipsis; 
									-webkit-box-orient: vertical;
									-webkit-line-clamp: 1;
								}
								.subtitle{
									color: $indexColor3;
									font-size: 16px;
									margin-top: 8px;
									line-height: 25px;
									max-height: 50px;
									overflow: hidden;
									display: -webkit-box;
									word-break: break-all;
									text-overflow: ellipsis; 
									-webkit-box-orient: vertical;
									-webkit-line-clamp: 2;
								}
							}
						}
						.box_item:hover{
							.subtitle{
								color: #BB0000;
							}
							.title{
								color: #BB0000;
							}
						}
					}
				}
				&_right{
					width: $indexRightWidth;
					.szyw_list{
						margin-top: 20px;
						width: 100%;
						.gxph_item{
							line-height: 36px;
							overflow: hidden;
							font-size: 18px;
							margin-bottom: 10px;
							color: $indexColor3;			
							padding-left: 20px;
							box-sizing: border-box;
							width: 100%;
							font-weight: bold;
							display: flex;
							align-items: center;
							font-family: $indexFontTitle;
							span:nth-child(1){
								display: block;
								line-height: 30px;
								height: 30px;
								width: 30px;
								margin-right: 10px;
								text-align: center;
								img{
									width: 100%;
									height: 100%;
								}
							}
							span:nth-child(2){
								flex: 1;
								margin-right: 10px;
							}
							.count{
								font-size: 14px;
								color: rgba($color: #000000, $alpha: 0.4);
								font-family: $indexFontSubTitle;
							}
						}
						.gxph_item:nth-child(1){
							color: $indexColor2;
						}
						.gxph_item:nth-child(2){
							color: $indexColor2;
						}
						.gxph_item:nth-child(3){
							color: $indexColor2;
						}
					}
				}
			}
			// 获奖
			.reward{
				margin: $indexMargin 0;
				width: 100%;
				display: flex;
				justify-content: space-between;
				>div{
					width: 590px;
				}
				&_left{
					// width: $indexLeftWidth;
				}
				&_right{
					// width: $indexRightWidth;
				}
				&_list{
					width: 100%;
					display: flex;
					flex-wrap: wrap;
					.item1{
						cursor: pointer;
						margin-top: 10px !important;
						font-size: 16px;
						width: 280px;
						line-height: 22px;
						overflow: hidden;
						height: 22px;
						margin-right: 15px !important;
						overflow: hidden;
					}
					.item1:hover{
						color: #BB0000;
					}
					.item{
						cursor: pointer;
						margin-top: 24px;
						margin-right: 20px;
						width: 280px;
						.left_img{
							position: relative;
							width: 100%;
							background: #808080;
							height: 168px;
							overflow: hidden;
							img{
								position: absolute;
								height: 100%;
								width: 100%;
								object-fit: cover;
								transition: all 0.3s;
							}
							.title{
								position: absolute;
								z-index: 11;
								width: 100%;
								line-height: 36px;
								padding: 0 10px;
								box-sizing: border-box;
								color: #fff;
								font-size: 14px;
								overflow: hidden;
								bottom: 0;
								background: rgba(56, 56, 56, 0.7);
								height: 36px;
							}
						}
						.right_words{
							width: 100%;
							.title{
								color: $indexColor;
								font-size: 14px;
								font-family: $indexFontSubTitle;
								margin-top: 10px;
								line-height: 24px;
								height: 24px;
								overflow: hidden;
								display: -webkit-box;
								word-break: break-all;
								text-overflow: ellipsis; 
								-webkit-box-orient: vertical;
								-webkit-line-clamp: 1;
							}
						}
					}
					.item:nth-child(2){
						margin-right: 0;
					}
					.item:hover{
						.right_words .title{
							color: #bb0000;
						}
						img{
							transform: scale(1.1);
						}
					}
				}
			}
			// 红色圣地
			.redplaceWrap{
				width: 100%;
				margin-top: $indexMargin;
				.redplace{
					margin-top: $indexMargin;
					width: 100%;
					height: 316px;
					.swiper-slide{
						width: 674px !important;
						height: 100% !important;
						img{
							width: 100%;
							height: 100%;
						}
					}
					.swiper-button-next{
						background: url(../../assets/home/next.png) no-repeat;
						background-size: 100% 100%;
					}
					.swiper-button-prev{
						background: url(../../assets/home/prev.png) no-repeat;
						background-size: 100% 100%;
					}
					.swiper-button-next, .swiper-button-prev {
					    width: 28px !important;
					    height:28px !important;
						margin-top: -14px !important;
					}
					.swiper-button-next:after, .swiper-container-rtl .swiper-button-prev:after {
					    content: '' !important;
					}
					.swiper-button-prev:after, .swiper-container-rtl .swiper-button-next:after {
					    content: '' !important;
					}
				}
			}
			// 优质资源
			.goodRoursce{
				width: 100%;
				margin-top: $indexMargin;
				.goodlist{
					width: 100%;
					display: flex;
					flex-wrap: wrap;
					margin-top: $indexMargin;
					.item{
						cursor: pointer;
						width: 280px;
						margin-left: 20px;
						margin-bottom: 20px;
						border: 1px solid #DDDDDD;
						box-sizing: border-box;
						cursor: pointer;
						.top_img{
							width: 100%;
							height: 183px;
							overflow: hidden;
							img{
								width: 100%;
								height: 100%;
								object-fit: cover;
								transition: all 0.3s;
							}
						}
						.bottom{
							padding: 12px 17px;
							overflow: hidden;
							box-sizing: border-box;
							.title{
								font-weight: bold;
								font-size: 16px;
								font-family: $indexFontSubTitle1;
								line-height: 24px;
								max-height:  48px;
								color: $indexColor;
								margin-bottom: 10px;
								overflow: hidden;
								display: -webkit-box;
								word-break: break-all;
								text-overflow: ellipsis; 
								-webkit-box-orient: vertical;
								-webkit-line-clamp: 1;
							}
							.sub_title{
								color: $indexColor3;
								font-size: 14px;
								line-height: 24px;
								max-height: 48px;
								overflow: hidden;
								display: -webkit-box;
								word-break: break-all;
								text-overflow: ellipsis; 
								-webkit-box-orient: vertical;
								-webkit-line-clamp: 2;
							}
						}
					}
					.item:hover{
						img{
							transform: scale(1.1);
						}
						.title{
							color: #bb0000;
						}
						.sub_title{
							color: #bb0000;
						}
					}
				}
			}
			// 入驻院校
			.school{
				width: 100%;
				margin-top: $indexMargin;
				&_swiper{
					margin-top: 0;
					width: 100%;
					height: 384px;
					font-size: 0;
					.swiper-slide{
						display: flex;
						align-items: center;
						justify-content: center;
						width: 286px !important;
						height: 169px !important;
						background: #F9F9F9;
						border-radius: 2px;
						div{
							text-align: center;
							img{
								width: 67px;
								height: 67px;
								margin: auto;
							}
							.school_name{
								width: 100%;
								font-size: 18px;
								color: $indexColor;
								margin-top: 24px;
							}
						}
					}
				}
				.swiper-pointer{
					position: relative;
					text-align: center;
					margin-top: $indexMargin;
					width: 100%;
					.swiper-pagination-bullet {
						background: #CB272B !important;
						opacity: 0.39;
					}
					.swiper-pagination-bullet-active{
						opacity: 1 !important;
						background: #CB272B !important;
					}
				}
			}
		}
	}
</style>
